/* global axios */

const KnowledgeBasesAPI = {
  get(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/knowledge_bases`);
  },

  show(accountId, id) {
    return axios.get(`/api/v1/accounts/${accountId}/knowledge_bases/${id}`);
  },

  create(accountId, data) {
    return axios.post(`/api/v1/accounts/${accountId}/knowledge_bases`, data);
  },

  update(accountId, id, data) {
    return axios.patch(`/api/v1/accounts/${accountId}/knowledge_bases/${id}`, data);
  },

  delete(accountId, id) {
    return axios.delete(`/api/v1/accounts/${accountId}/knowledge_bases/${id}`);
  },

  search(accountId, params) {
    return axios.post(`/api/v1/accounts/${accountId}/knowledge_bases/search`, params);
  },
};

export default KnowledgeBasesAPI;
